var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.currentProduct)?_c('div',{staticClass:"custom"},[_c('div',{staticClass:"custom__wrapper"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.currentProduct.additionalTabs.data[0].content)}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }